export default __webpack_public_path__ + "static/media/fb_intro.d8f5a883.png";